import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const redemptionProductSlide = createSlice({
    name: "redemptionProduct",
    initialState: {
        page: 0,
        pageCount: 0,
        listData: null,
        summaryData: null,

        success: false,
        fail: false,
        
        detailData: null,
        responseData: null,
        errorDetailData: null,
    },
    reducers: {
        doGetRedemptionProductListSuccess: (state, action) => {
            state.listData = action.payload.data;
            state.page = action.payload?.current_page;
			state.pageCount = action.payload?.page_count;
        },
        doGetRedemptionProductListFail: (state, action) => {
            state.listData = null;
            state.page = 0;
			state.pageCount = 0;
        },

        doGetRedemptionProductSummarySuccess: (state, action) => {
            state.summaryData = action.payload?.data;
        },
        doGetRedemptionProductSummaryFail: (state, action) => {
            state.summaryData = null;
        },

        doGetRedemptionProductDetailSuccess: (state, action) => {
            state.detailData = action.payload.data;
        },
        doGetRedemptionProductDetailFail: (state, action) => {
            state.detailData = null;
        },

        doAddRedemptionProductSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
			state.responseData = action.payload;
        },
        doAddRedemptionProductFail: (state, action) => {
            state.success = false;
            state.fail = true;
			state.errorDetailData = action.payload;
        },

        doUpdateRedemptionProductSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
        },
        doUpdateRedemptionProductFail: (state, action) => {
            state.success = false;
            state.fail = true;
			state.errorDetailData = action.payload;
        },

        resetRedemptionProductStateSuccess: (state, action) => {
            state.success = action.payload;
            state.fail = action.payload;
			state.errorDetailData = null;
            state.assignSuccess = action.payload;
            state.assignFail = action.payload;
            state.assignReponseData = null;
            state.downloadQRSuccess = action.payload;
            state.downloadQRFail = action.payload;
        },

        resetRedemptionProductSuccess: (state, action) => {
            state.detailData = null;
        },
    },
});

export const doGetRedemptionProductList = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/redemption-product?page=${param.page}&size=${param.limit}`;
        if(param.filter) {
            url += `&filter=${encodeURIComponent(param.filter)}`;
        }

        const response = await axios.get(url);
        dispatch(doGetRedemptionProductListSuccess(response.data));
    } catch (error) {
        dispatch(doGetRedemptionProductListFail(error.response));
    }
};

export const doGetRedemptionProductSummary = () => async (dispatch) => {
    try {
        const url = `/api/admin/redemption-product/summary`;

        const response = await axios.get(url);
        dispatch(doGetRedemptionProductSummarySuccess(response.data));
    } catch (error) {
        dispatch(doGetRedemptionProductSummaryFail(error.response));
    }
};

export const doGetRedemptionProductDetail = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/redemption-product/${param.product_id}`;
       
        const response = await axios.get(url);
        dispatch(doGetRedemptionProductDetailSuccess(response.data));
    } catch (error) {
        dispatch(doGetRedemptionProductDetailFail(error.response));
    }
};

export const doAddRedemptionProduct = (param) => async (dispatch) => {
    try {
        const url = `/api/admin/redemption-product`;

        // Create FormData
        const formData = new FormData();

        // Add basic fields (name, sku, credit, stock_quantity, status)
        formData.append("name", param.name);
        formData.append("description", param.description);
        formData.append("point_required", param.point_required);
        formData.append("stock_quantity", param.stock_quantity);
        formData.append("status", param.status || "active");

        // Handle product_images object
        const productImages = param.product_images;
        
        if (productImages && typeof productImages === "object") {
            // Handle new image files
            if (productImages.images && Array.isArray(productImages.images)) {
                productImages.images.forEach((image) => {
                    if (image instanceof File) {
                        formData.append("images", image);
                    } else if (image.id) {
                        // Existing image - send ID
                        formData.append("existing_image_ids[]", image.id);
                    }
                });
            }

            // Handle deleted image IDs
            if (productImages.deleted_image_ids && productImages.deleted_image_ids.length > 0) {
                formData.append("deleted_image_ids", JSON.stringify(productImages.deleted_image_ids));
            }

            // Handle primary/cover image index
            if (typeof productImages.selected_image_index === "number") {
                formData.append("cover_image_index", productImages.selected_image_index);
            }
        }

        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        const response = await axios.post(url, formData, config);
        dispatch(doAddRedemptionProductSuccess(response.data));
    } catch (error) {
        dispatch(doAddRedemptionProductFail(error.response));
    }
};

export const doUpdateRedemptionProduct = (param, product_management_id) => async (dispatch) => {
    try {
        const url = `/api/admin/redemption-product/${product_management_id}`;

        // Create FormData
        const formData = new FormData();

        // Add basic fields (name, sku, credit, stock_quantity, status)
        formData.append("name", param.name);
        formData.append("description", param.description);
        formData.append("point_required", param.point_required);
        formData.append("stock_quantity", param.stock_quantity);
        formData.append("status", param.status || "active");

        // Handle product_images object
        const productImages = param.product_images;
        
        if (productImages && typeof productImages === "object") {
            // Handle new image files
            if (productImages.images && Array.isArray(productImages.images)) {
                productImages.images.forEach((image) => {
                    if (image instanceof File) {
                        formData.append("images", image);
                    } else if (image.id) {
                        // Existing image - send ID
                        formData.append("existing_image_ids[]", image.id);
                    }
                });
            }

            // Handle deleted image IDs
            if (productImages.deleted_image_ids && productImages.deleted_image_ids.length > 0) {
                formData.append("deleted_image_ids", JSON.stringify(productImages.deleted_image_ids));
            }

            // Handle primary/cover image index
            if (typeof productImages.selected_image_index === "number") {
                formData.append("cover_image_index", productImages.selected_image_index);
            }
        }

        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        };

        const response = await axios.put(url, formData, config);
        dispatch(doUpdateRedemptionProductSuccess(response.data));
    } catch (error) {
        dispatch(doUpdateRedemptionProductFail(error.response));
    }
};

export const resetRedemptionProductState = () => async (dispatch) => {
    dispatch(resetRedemptionProductStateSuccess(false));
};

export const resetRedemptionProduct = () => async (dispatch) => {
    dispatch(resetRedemptionProductSuccess(false));
};

export const { 
    doGetRedemptionProductListSuccess,
    doGetRedemptionProductListFail,

    doGetRedemptionProductSummarySuccess,
    doGetRedemptionProductSummaryFail,

    doGetRedemptionProductDetailSuccess,
    doGetRedemptionProductDetailFail,

    doAddRedemptionProductSuccess,
    doAddRedemptionProductFail,

    doUpdateRedemptionProductSuccess,
    doUpdateRedemptionProductFail,

    resetRedemptionProductStateSuccess,
    resetRedemptionProductSuccess,
} = redemptionProductSlide.actions;

export const getRedemptionProductList = (state) => state.redemptionProduct?.listData;
export const getRedemptionProductListPage = (state) => state.redemptionProduct?.page;
export const getRedemptionProductListPageCount = (state) => state.redemptionProduct?.pageCount;
export const getRedemptionProductSummary = (state) => state.redemptionProduct?.summaryData;

export const getRedemptionProductDetail = (state) => state.redemptionProduct?.detailData;
export const getRedemptionProductErrorDetailData = (state) => state.redemptionProduct?.errorDetailData;

export const getAddRedemptionProductSuccess = (state) => state.redemptionProduct?.success;
export const getAddRedemptionProductFail = (state) => state.redemptionProduct?.fail;
export const getAddRedemptionProductResponseData = (state) => state.redemptionProduct?.responseData;

export default redemptionProductSlide.reducer;
